import {TransformerInterface} from "./transformerInterface";
import {CommandDTO} from "../domain/dtos/command.dto";
import {ICommand} from "../commands/i-command.interface";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";

export abstract class AbstractCommandToDtoTransformer<T extends any> implements TransformerInterface<CommandDTO<any>, any> {

    public async transform(inputObject: ICommand<T>): Promise<CommandDTO<DataTransferObject>> {

        return <CommandDTO<DataTransferObject>>{
            uid: inputObject.uid,
            name: inputObject.name,
            mainEntityClass: inputObject.mainEntityClass,
            mainEntityUid: inputObject.mainEntityUid,
            payload: await this.toDTO(inputObject.payload)
        };

    }

    protected abstract toDTO(inputObject: any, payload?: any): Promise<DataTransferObject | DataTransferObject[]>;

}